export const SCOPE = 'module:viewerSessions';
export const GET_SCAN_DATA = `${SCOPE}/GET_SCAN_DATA`;
export const GET_SCAN_DATA_SUCCESSFUL = `${SCOPE}/GET_SESSIONS_DATA_SUCCESSFUL`;
export const GET_SCAN_DATA_FAIL = `${SCOPE}/GET_SESSIONS_DATA_FAIL`;
export const UPDATE_TABLE_COLUMNS = `${SCOPE}/UPDATE_TABLE_COLUMNS`;
export const SET_VIEWER_SESSIONS_PARAMS = `${SCOPE}/SET_VIEWER_SESSIONS_PARAMS`;
export const UPDATE_SELECTED_METRICS = `${SCOPE}/UPDATE_SELECTED_METRICS`;
export const UPDATE_METRIC_ANCHOR = `${SCOPE}/UPDATE_METRIC_ANCHOR`;
export const CHANGE_TIME_LIMIT = `${SCOPE}/CHANGE_TIME_LIMIT`;
export const CHANGE_FUNC_DATA = `${SCOPE}/CHANGE_FUNC_DATA`;
export const SET_DATA_TYPE = `${SCOPE}/SET_DATA_TYPE`;
export const ADD_TABLE_DATA = `${SCOPE}/ADD_TABLE_DATA`;
export const SAVE_SCAN_QUERY = `${SCOPE}/SAVE_SCAN_QUERY`;
